// extracted by mini-css-extract-plugin
export default {"rightIconColor":"nav-file-language-option-module__rightIconColor--hJCLd","languagePopup":"nav-file-language-option-module__languagePopup--vkOaE"};